import { ExamCenterProctorRequestIdType } from '@exam-center/graphql';

import { type ProctorRequestCreationFormInput } from '../../providers';

interface UploadFileName {
  uploadFileName: string;
  originalFileName: string;
}

export function createExamCenterProctorRequestPayload(
  data: ProctorRequestCreationFormInput,
  agreementFileNames: UploadFileName[],
  personalInfoFileNames: UploadFileName[],
  examCenterCode: string,
) {
  const idNumber = data.personal.idNumber.replace(/-/g, '');
  const phoneNumber = data.personal.phoneNumber?.replace(/-/g, '');

  return {
    type: data.proctorType,
    firstNameTh: data.personal.firstNameTh,
    lastNameTh: data.personal.lastNameTh,
    titleTh: data.personal.titleTh.value,
    titleEn: data.personal.titleEn.value,
    firstNameEn: data.personal.firstNameEn,
    lastNameEn: data.personal.lastNameEn,
    email: data.personal.email,
    phoneNumber,
    address: data.personal.address,
    employeeId: data.employeeInfo.code,
    position: data.employeeInfo.position,
    department: data.employeeInfo.department,
    startedAt: data.employeeInfo.startedAt,
    endedAt: data.employeeInfo.termination.endedAt,
    agreementFileNames: agreementFileNames,
    personalInfoFileNames: personalInfoFileNames,
    idNumber,
    idType: ExamCenterProctorRequestIdType.CitizenCard,
    examCenterCode,
  };
}
